import { render, staticRenderFns } from "./MPopupStoreHours.vue?vue&type=template&id=5b94e849&"
import script from "./MPopupStoreHours.ts?vue&type=script&lang=ts&"
export * from "./MPopupStoreHours.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports